import { render } from "./ModalCustomerServiceChannels.vue?vue&type=template&id=3effaa64&ts=true"
import script from "./ModalCustomerServiceChannels.vue?vue&type=script&lang=ts"
export * from "./ModalCustomerServiceChannels.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__